'use strict';

export default angular
  .module('maestro.directives.common.repeat-item-complete', [])

  .directive('repeatItemComplete', function($timeout) {
    return function(scope, element, attrs) {
      $timeout(function() {
        scope.$eval(attrs.repeatItemComplete);
      }, 0);
    };
  })

  .name;
